<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<form id="FormTipoEvento" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
				<div class="container-fluid">
					<div class="row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12">
							<div class="form-group form-row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<label for="Nombre">Nombre</label>
									<input type="text" v-model="objTipoEvento.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
									<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
								</div>
							</div>
		
							<div class="form-group form-row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<label for="Etiqueta">Etiqueta En Español</label>
									<input type="text" v-model="objTipoEvento.Etiqueta" class="form-control" id="Etiqueta" placeholder="Ingresar Etiqueta" />
									<CValidation v-if="this.errorvalidacion.Etiqueta" :Mensaje="'*'+errorvalidacion.Etiqueta[0]"/>
								</div>
							</div>
		
							<div class="form-group form-row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<label for="EtiquetaIng">Etiqueta en Ingles</label>
									<input type="text" v-model="objTipoEvento.EtiquetaIng" class="form-control" id="EtiquetaIng" placeholder="Ingresar Etiqueta en Ingles" />
									<CValidation v-if="this.errorvalidacion.EtiquetaIng" :Mensaje="'*'+errorvalidacion.EtiquetaIng[0]"/>
								</div>
							</div>
								
							<br>
						</div><!--fin col-12-->
					</div>
				</div>
			</form>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormTipoEvento',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objTipoEvento: {
				IdTipoEvento: 0,
				Nombre: '',
				Etiqueta: '',
				EtiquetaIng: '',
				IdEmpresa: 0,
				IdSucursal: 0,
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objTipoEvento.IdTipoEvento == 0) {
				await this.$http.post(
					'tipoEventos',this.objTipoEvento
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'tipoEventos/'+this.objTipoEvento.IdTipoEvento,
					this.objTipoEvento
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "tipoEventos/"+this.objTipoEvento.IdTipoEvento
            ).then((res) => {
                this.objTipoEvento = res.data.data;

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objTipoEvento = {
				IdTipoEvento: 0,
				Nombre: '',
				Etiqueta: '',
				EtiquetaIng: '',
				IdEmpresa: 0,
				IdSucursal: 0,
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objTipoEvento.IdTipoEvento = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
